export default __webpack_public_path__ + "8b38296669bec22d7f47e8785b4e8c25.svg";